/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAddress } from './UserAddress';
import {
    UserAddressFromJSON,
    UserAddressFromJSONTyped,
    UserAddressToJSON,
    UserAddressToJSONTyped,
} from './UserAddress';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    fullName: string | null;
    /**
     * 
     * @type {UserAddress}
     * @memberof User
     */
    address: UserAddress;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    companyLegalId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    birthdate: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    roles: Array<UserRolesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    wantsDonationReceipt: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    subscribesToNewsletter: boolean;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    projectsCount: number;
}


/**
 * @export
 */
export const UserRolesEnum = {
    User: 'ROLE_USER',
    Admin: 'ROLE_ADMIN'
} as const;
export type UserRolesEnum = typeof UserRolesEnum[keyof typeof UserRolesEnum];


/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('companyLegalId' in value) || value['companyLegalId'] === undefined) return false;
    if (!('birthdate' in value) || value['birthdate'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('wantsDonationReceipt' in value) || value['wantsDonationReceipt'] === undefined) return false;
    if (!('subscribesToNewsletter' in value) || value['subscribesToNewsletter'] === undefined) return false;
    if (!('projectsCount' in value) || value['projectsCount'] === undefined) return false;
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'fullName': json['fullName'],
        'address': UserAddressFromJSON(json['address']),
        'phoneNumber': json['phoneNumber'],
        'companyLegalId': json['companyLegalId'],
        'birthdate': (json['birthdate'] == null ? null : new Date(json['birthdate'])),
        'roles': json['roles'],
        'wantsDonationReceipt': json['wantsDonationReceipt'],
        'subscribesToNewsletter': json['subscribesToNewsletter'],
        'projectsCount': json['projectsCount'],
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'fullName': value['fullName'],
        'address': UserAddressToJSON(value['address']),
        'phoneNumber': value['phoneNumber'],
        'companyLegalId': value['companyLegalId'],
        'birthdate': (value['birthdate'] == null ? null : (value['birthdate'] as any).toISOString()),
        'roles': value['roles'],
        'wantsDonationReceipt': value['wantsDonationReceipt'],
        'subscribesToNewsletter': value['subscribesToNewsletter'],
        'projectsCount': value['projectsCount'],
    };
}

